import Vue from 'vue'
import Router from 'vue-router'

import GameLobby from '@/views/GameLobby'
import LoadingAnimate from '@/components/layout/loadingAnimate'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: {
        name: 'GameLobby'
      }
    },
    {
      path: '/GameLobby',
      name: 'GameLobby',
      component: GameLobby,
      meta: {
        requiresAuth: false
      }
    },
    // {
    //   path: '/LoadingAnimate',
    //   name: 'LoadingAnimate',
    //   component: LoadingAnimate,
    //   meta: {
    //     requiresAuth: false
    //   }
    // },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

